export interface IToast {
  id: number
  type: MODAL_TYPE
  exp?: number
  info: string
  show?: boolean
  translateParams?: any
}
export enum MODAL_TYPE {
  WARNING,
  ERROR,
  SUCCESS,
}
